import { FedexAccountOutDTO } from '@api/ringil-api.v2';

/** "604849268 (Brno warehouse)" - the account number is what FedEx and the labels show. */
export const fedexAccountLabel = (account: Pick<FedexAccountOutDTO, 'accountNumber' | 'name'>): string =>
  account.name ? `${account.accountNumber} (${account.name})` : account.accountNumber;
